export default function ({ value, children, onClick, ...others }) {
  const copyCodeToClipboard = (e) => {
    navigator.clipboard
      .writeText(value)
      .then(function () {
        console.log("Text successfully copied to clipboard");
      })
      .catch(function (error) {
        console.error("Failed to copy text: ", error);
      })
      .finally(() => {
        if (onClick) {
          onClick(e);
        }
      });
  };

  return (
    <>
      <button {...others} onClick={copyCodeToClipboard}>
        {children}
      </button>
    </>
  );
}
